const ID = {
	ABOUT: "about",
	GALLERY: "gallery",
	OFFERINGS: "offerings",
	TESTIMONIALS: "testimonials",
	REQUEST: "contact-us",
};

export default ID;
